import { Button, ButtonSize, ButtonVariation, Paper, SwitchCurrency, TypographyElement } from 'UI'

import { createUseStyles, useTheme } from 'react-jss'
import style from './style'
import { defaultCurrency } from 'store/currency'
import Text from './text.json'

const useStyles = createUseStyles(style)

export default ({
  Price,
  AlternativePrice,
  PricePromo,
  AlternativePricePromo,
  loading,
  handleChangeCurrency,
  addToCart,
  initialCurrency,
  alternativeCurrency,
  isDefault,
  Image,
  MobileImageUrl,
  Title,
  Id,
  Rating,
  ReviewersCount,
  Duration,
  ViewersCount,
  Slug
}) => {
  const theme = useTheme()
  const { paper, switchCurrencyStyle } = useStyles()
  const usingEuro = initialCurrency === defaultCurrency
  const promoExist = PricePromo || AlternativePricePromo
  if (loading) return null
  return (
    <Paper className={paper}>
      {
        isDefault
          ? null
          : (
            <div className={switchCurrencyStyle}>
              <SwitchCurrency
                handleChange={handleChangeCurrency}
                devis={defaultCurrency}
                alterDevis={alternativeCurrency}
                checked={initialCurrency !== defaultCurrency}
              />
            </div>
            )
        }
      <TypographyElement
        variant='heading3'
        color={promoExist ? theme.success[0] : null}
      >
        {usingEuro ? PricePromo || Price : AlternativePricePromo || AlternativePrice}
        <TypographyElement
          variant='heading3'
          fontSize='1.074rem'
          Component='span'
          display='inline-block'
          lineHeight='0px'
          spacing='0 0 0 4px'
          color={promoExist ? theme.success[0] : null}
        >
          {initialCurrency}
        </TypographyElement>
        {
          promoExist
            ? (
              <TypographyElement
                variant='heading5'
                display='inline-block'
                Component='span'
                textDecoration='line-through'
                spacing='0 0 0 8px'
              >
                {usingEuro ? Price : AlternativePrice}
                <TypographyElement
                  variant='heading3'
                  fontSize='1.074rem'
                  Component='span'
                  display='inline-block'
                  lineHeight='0px'
                  spacing='0 0 0 4px'
                  textDecoration='line-through'
                >
                  {initialCurrency}
                </TypographyElement>
              </TypographyElement>
              )
            : null
        }
      </TypographyElement>
      <TypographyElement
        variant='caption'
        margin='-3px 0 0 0'
      >
        {Text.satisfiedOrRefunded}
      </TypographyElement>
      <Button
        variation={ButtonVariation.primary}
        size={ButtonSize.small}
        label={Text.accessTheTraining}
        width='100%'
        marginButton='22px 0 0 0'
        onHandleClick={() => addToCart({
          Image,
          MobileImageUrl,
          Title,
          Price,
          Id,
          Rating,
          ReviewersCount,
          Duration,
          ViewersCount,
          Slug,
          AlternativePrice,
          PromotionPrice: PricePromo,
          AlternativePricePromo
        })}
      />
    </Paper>
  )
}
